import Vue from 'vue';
import Router from 'vue-router';
import { getToken } from '@/utils/auth';
import store from '../store/store';

import { menus } from './menus';
import { routerGroup } from './routerGroup'
;

const home = () => import('@/views/home.vue');
const login = () => import('@/components/login.vue');
const register = () => import('@/components/register.vue');

Vue.use(Router);


const routes = [
  {
    path: '/login',
    component: login,
    name: 'login',
    meta: {
      title: 'Login',
    },
  },
  {
    path: '/register',
    component: register,
    name: 'register',
    meta: {
      title: 'register',
    },
  },
  {
    path: '/',
    name: 'home',
    component: home,
    children: [
      // ...menus,
      ...routerGroup,
    ],
  },
];
const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
});
router.beforeEach((to, from, next) => {
  if (to.meta.needLogin && store.state.loginFlag) { // 如果需要登录的页面已登录
    if (store.state.userInfo.checkFlag != '1') { // 判断是否通过审核，未通过审核，提示xxx 跳到首页
      // 这里写提示信息代码
      // next('/')
      to.isShow = false;
    } else {
      // next();
      to.isShow = true;
    }
  } else if (to.meta.needLogin) { // 需要登录的页面
    next('/');
  } else { // 可以直接进入的页面
    next();
  }
});
export default router;
